import React from "react";
import dev from "../../images/certificate.svg"
import "./Education.css";

const Education = () => {
  return (
    <div className="edContainer">
      <div className="subContainer" id="educationCont">
        <h2>Education:</h2>
        <img src={dev} id="componentImg" />
          <ul>
            <p>University of Denver Full Stack Coding Bootcamp</p>
            <p>December '20</p>
          </ul>

          <h2>Contact: </h2>

          <ul>
            <p id="emailAdd">ali.hernandez9two@gmail.com</p>
          </ul>
      </div>
    </div>
  );
};

export default Education;

//a href="https://docs.google.com/document/d/1HfO7EoBMV-xKG8VwBZy7KIfKpd2i5ta-Kq9GEGOsHKE/edit?usp=sharing">Resume</a>
